module.exports = __webpack_public_path__ + "static/img/nonghua.869aaec9.png";